import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class Capmsprefilloption extends Model {
  [Type] = 'capmsprefilloption' as const;

  @attr() declare bookingRoomNames: string[];
  @attr() declare pmsPersons: number[];
  @attr() declare pmsPrettyNamesToPmsIds: Record<string, unknown>;
  @attr() declare pmsPrettyRoomNamesToShortNames: Record<string, unknown>;
  @attr() declare pmsRootRateIdMapping: Record<string, unknown>;
}
